// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"e9408135","305":"eb35ea19","555":"2c6dc60e","754":"a1d02bd1","866":"ecd05dcb","985":"f3433a8f"}[chunkId] + ".chunk.css";
};